import { innerPayloadKey } from './activity';
import { ComponentType, LectureComponent } from './lecture-component';

export interface AiCreationCommands {
  id: number,
  requester: Requester,
  courseId: number,
  aiCreationSourceIds: number[],
  contentLength: string,
  styleSourceCourseId: string,
  inProgress: boolean,
  summary: string,
  processingError: ProcessingError,
}

export interface Requester {
  id: number,
  firstName: string,
  lastName: string,
  email: string,
  hasSeenCompletionModal: boolean,
}

export interface ProcessingError {
  status: string,
  message: string,
}

export interface AiSuggestedComponentSet {
  id: string,
  activity: LectureComponent,
  secondaryActivities: LectureComponent[],
  relatedSetId?: string,
}

export interface AiSuggestedComponentProps {
  componentSet: AiSuggestedComponentSet
}

// Components that can be suggested by AI
export const aiSuggestingComponents = [
  ComponentType.QUIZ,
  ComponentType.POLL,
  ComponentType.EXERCISE,
  ComponentType.PUBLIC_PEER_EVALUATION,
  ComponentType.SURVEY,
  ComponentType.TOPIC,
  ComponentType.MEET_AND_GREET,
  ComponentType.PROFILE_COMPLETION,
];

/**
 * These are the components that can be created through AI suggestions. This list
 * differs from aiSuggestingComponents, as some components, such as Meet and Greet,
 * also generate an additional header component along with the main component.
 */
export const aiSuggestionCreatableComponents = [
  ...aiSuggestingComponents,
  ComponentType.HEADER_STYLE1,
];

export const regeneratableAISuggestionComponents = [
  ComponentType.QUIZ,
  ComponentType.TOPIC,
];

const aiComponentParamKeys = {
  ...innerPayloadKey,
  [ComponentType.SURVEY]: ['post_survey', 'pre_survey'],
  [ComponentType.EXERCISE]: 'assignment',
  [ComponentType.PUBLIC_PEER_EVALUATION]: 'public_feedback',
  [ComponentType.TOPIC]: 'discussion',
  [ComponentType.MEET_AND_GREET]: 'meet_and_greet',
  [ComponentType.PROFILE_COMPLETION]: 'profile_completion',
};

/**
 * Flattened array of all component's URL param keys for AI-suggested components.
 * Because some components map to multiple param keys (eg. Survey), we need to flatten the array.
 */
export const aiSuggestingComponentsParamKeys = aiSuggestingComponents.map(key => aiComponentParamKeys[key]).flat();
